import type { QuoteHeader, QuoteItem } from '@shared/schema';

export interface PdfExportOptions {
  agbText?: string;
  signatureImage?: string;
  signatureName?: string;
  signatureTitle?: string;
  discountAmount?: number;
  discountType?: 'percent' | 'absolute';
  discountApplicationMode?: 'total' | 'distributed';
  isDiscountAppliedToPrices?: boolean;
  vatRate?: number;
  showPrices?: boolean;
  aiOptimization?: 'light' | 'max';
}

export interface PdfExportSnapshot {
  header: QuoteHeader;
  items: QuoteItem[];
  gewerkOrder: string[];
  options: PdfExportOptions;
}

function cloneAndFreeze<T>(value: T): T {
  if (Array.isArray(value)) {
    return Object.freeze(value.map((entry) => cloneAndFreeze(entry))) as T;
  }

  if (value !== null && typeof value === 'object') {
    const clone = Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, cloneAndFreeze(entry)]),
    );
    return Object.freeze(clone) as T;
  }

  return value;
}

export function capturePdfExportSnapshot(
  input: PdfExportSnapshot,
): Readonly<PdfExportSnapshot> {
  return cloneAndFreeze(input);
}
